import { render, staticRenderFns } from "./SidebarLink.vue?vue&type=template&id=232bdae9&scoped=true"
import script from "./SidebarLink.vue?vue&type=script&lang=js"
export * from "./SidebarLink.vue?vue&type=script&lang=js"
import style0 from "./SidebarLink.vue?vue&type=style&index=0&id=232bdae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bdae9",
  null
  
)

export default component.exports